import { render } from "./UpgradePackageConfirmationView.vue?vue&type=template&id=cf10a076&scoped=true"
import script from "./UpgradePackageConfirmationView.vue?vue&type=script&lang=js"
export * from "./UpgradePackageConfirmationView.vue?vue&type=script&lang=js"

import "./UpgradePackageConfirmationView.vue?vue&type=style&index=0&id=cf10a076&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf10a076"]])

export default __exports__